// extracted by mini-css-extract-plugin
export default {"link":"LinkAccounts_link__E6UyH","form__group":"LinkAccounts_form__group__5ZHNx","link__btns":"LinkAccounts_link__btns__c8iTI","form__error":"LinkAccounts_form__error__ZEXFb"};